import axios from 'axios';
import ENV from '../../../environment';

export default {
  state: {
    width: 0,
    depth: 0,
    addedWidth: 0,
    addedDepth: 0,
  },

  mutations: {
    setWidth(state, width) {
      state.width = width;
    },

    setDepth(state, depth) {
      state.depth = depth;
    },

    setAddedWidth(state, addedWidth) {
      state.addedWidth = addedWidth;
    },

    setAddedDepth(state, addedDepth) {
      state.addedDepth = addedDepth;
    },
  },

  actions: {

  },

  getters: {
    totalWidth(state) {
      return Number(state.width) + Number(state.addedWidth / 100);
    },

    totalDepth(state) {
      return Number(state.depth) + Number(state.addedDepth / 100);
    },
  }

};
